<template>
  <a-popover title="商品规格" placement="bottom">
    <template slot="content">
      <div style="width: 300px">
        <div v-for="(item, index) in sku.tree" :key="index">
          <span>{{ item.k }}</span>
          <div class="attr-box">
            <span
              class="attr-item"
              v-for="(attr, a) in item.v"
              :key="a"
              @click="skuChoose(index, a, attr)"
            >
              <a-button
                v-if="!dianji"
                :type="attr.checked ? 'primary' : 'dashed'"
                >{{ attr.name }}</a-button
              >
            </span>
          </div>
        </div>
        <a-button type="primary" @click="onSkuChecked"> 确定 </a-button>
        <a-button  @click="onSkuReset"> 重置 </a-button>
      </div>
    </template>
    <a-input
      style="width: 300px"
      v-model="sku_name"
      :allowClear="true"
      placeholder="请选择商品规格"
      @input="onSkuReset"
    />
  </a-popover>
</template>
<script>
export default {
  name: "SkuPicker",
  data() {
    return {
      dianji: false,
      sku_list: [], 
      k_s_checked:{}, //选中的条件,
      checked_sku_list:[], //选中的sku
      sku_checked_ok:false //规格是否选中完毕
    };
  },
  props: {
    sku_data: {
      type: Object,
      required: true,
    },
    sku_id: {
      type: Number | String,
      default: 0,
    },
    sku_name: {
      type: String,
      default: "",
    },
    sku:{
      type: Object,
      required: true,
    }
  },
  mounted() {
    console.log(this.sku)
    console.log(this.sku_name)
    this.skuPickerShow()
  },
  methods: {
    skuChoose(findex,aindex,attr){
      // console.log(e);
      this.dianji = true;
      let that = this; 
      if (attr.disabled){
        //禁止选择
        return ;
      }
      // if (that.sku.tree[findex].v.length == 1) {
      //   //仅有一个属性
      //   return;
      // }
      that.sku.tree[findex].v.map((child) => { 
          child.checked = false; 
      }); 
      console.log('that.data.sku.tree[findex].v[aindex].checked', that.sku.tree[findex].v[aindex].checked);
      if (attr.checked){
        //取消选中 
          that.sku.tree[findex].v[aindex].checked = false;  
      }else{
        //选中
        that.sku.tree[findex].v[aindex].checked = true;
      }  
      // var s = 'sku.tree[' + findex + ']'
      this.sku.tree[findex]=that.sku.tree[findex]
      // that.setData({
      //   [s]: that.data.sku.tree[findex]
      // });
      that.skuCompute();
      that.dianji = false
    },
    skuPickerShow() { 
      let that = this; 
      that.sku.tree.map((field,findex) => {
        if (field.v.length==1){
          that.sku.tree[findex].v[0].checked=true
        }
      });
      that.skuCompute();
       
    },
    skuCompute(){
      //过滤sku-list
      console.log('skuCompute');
      let that = this;
      let k_s_checked = {};
      that.sku.tree.map((field) =>{
        var hasChecked = field.v.filter(attr=>{
          return attr.checked
        });
        if (hasChecked.length>0){
          // k_s_checked.push({
            // 'k': field.k_s,
            // 'v': hasChecked[0].id,
          // });
          k_s_checked[field.k_s] = hasChecked[0].id;
        } 
      }); 
      //选中的条件
      console.log('k_s_checked', k_s_checked); 
      let checked_sku_list = that.checkedSkuFilter(k_s_checked);
      that.k_s_checked=k_s_checked
      that.checked_sku_list=checked_sku_list
      

      //选中的sku
      console.log('checked_sku_list', checked_sku_list);
      // that.skuTitleCompute();
      // that.disabledCompute();
      that.buyCountCompute();
    },

    buyCountCompute(){
      let that = this;
      if (that.checked_sku_list.length > 2) { 
        that.sku_checked_ok =false 
        return false;
      }else{ 
        that.sku_checked_ok= true
      }

    },

    checkedSkuFilter(k_s_checked){
      let that =this;
      let checked_sku_list = [];
      that.sku.list.map(row => {
        // if (k_s_checked)
        // console.log('xxxx') 
        for (let kitem in k_s_checked) {
          if (row[kitem] != k_s_checked[kitem]) {
            return;
          }
        }
        checked_sku_list.push(row);
      })
      return checked_sku_list
    },

     
     
    onSkuChecked() {
      if(!this.sku_checked_ok){
        this.$message.error('请将规格补充完整')
        return
      }
      let arr = [];
      console.log(this.sku.tree)
      this.sku.tree.map((item, i) => {
        item.v.map((attr, a) => {
          if (attr.checked) {
            arr.push(attr);
          }
        });
      });
 
      console.log(arr)
      this.sku_id=this.checked_sku_list[0].id
      let name=''
      let p=''
      arr.map((item,i)=>{
        if(i!=0){
          p='/'
        }
        name+=p+item.name
      })
      // this.sku_name=name
      let value={sku_id:this.checked_sku_list[0].id,sku_name:name,goods_price:this.checked_sku_list[0].price/100,inside_price:this.checked_sku_list[0].inside_price/100,stock:this.checked_sku_list[0].stock_num}
      console.log(value)
      this.$emit('onSkuChecked',value)
      // console.log(this.check_sku_list);
    },
    onSkuReset(){
      this.check_sku_list=[]
      this.dianji=true
      this.sku_data.sku_fields_list.map((item,i)=>{
        item.attrs.map((attr,a)=>{
          attr.check=false
        })
      })
      this.dianji=false
      let value={sku_id:0,sku_name:'',goods_price:0}
      this.$emit('onSkuChecked',value)
    }
  },
};
</script>
<style>
.attr-box {
  display: flex;
  width: 300px;
  align-items: center;
  flex-wrap: wrap;
}
.attr-item {
  display: inline-block;
  padding: 4px 5px;
}
</style>
